module.exports = __webpack_public_path__ + "img/Front Window.86003915.png";